import { get } from 'lodash-es';
import { useEffect, useState } from 'react';

import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { usePrevious } from '@hook/common/use-previous.hook';
import { useLazyLoadLimitCredentialsQuery } from '@hook/credential/credential.hooks';
import { useStoreSelector } from '@hook/store/store.hooks';
import { PaginationOffsetResponseInterface } from '@interface/logs/response-data.interface';
import { isExist } from '@util/data/is-exist';

const PAGINATION_PER_PAGE = 10;

export const useApplicationCredentials = () => {
  const application = useCurrentApplication();
  const [action, { isLoading, data }] = useLazyLoadLimitCredentialsQuery();
  const count = useStoreSelector((state) => state.credentials.data.length);
  const prevCount = usePrevious(count);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(
    () =>
      void (
        isExist(prevCount) &&
        prevCount !== count &&
        action({
          applicationId: application.current.id,
          pagination: {
            offset: currentPage * PAGINATION_PER_PAGE,
            limit: PAGINATION_PER_PAGE,
          },
        })
      ),
    [application.current.id, count, prevCount, currentPage],
  );
  useEffect(
    () =>
      void action({
        applicationId: application.current.id,
        pagination: {
          offset: currentPage * PAGINATION_PER_PAGE,
          limit: PAGINATION_PER_PAGE,
        },
      }),
    [application.current.id, currentPage],
  );

  return {
    data: get(data, 'data', []),
    isLoading,
    pagination: get(data, 'meta') as PaginationOffsetResponseInterface,
    onPage: setCurrentPage,
  };
};
